import React from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 text-slate-900 font-sans selection:bg-amber-500 selection:text-white">
      {/* Navbar */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-slate-200 h-16 flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full flex justify-between items-center">
          <div className="flex-shrink-0 cursor-pointer" onClick={() => navigate('/')}>
             <span className="text-xl font-black text-slate-900 tracking-tighter">
                STOCKINU
             </span>
          </div>
          <div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-40 pb-24 overflow-hidden">
        {/* Background decorative elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
             <div className="absolute top-[-10%] right-[-5%] w-[600px] h-[600px] bg-amber-200/30 rounded-full blur-[100px]" />
             <div className="absolute bottom-[-10%] left-[-10%] w-[500px] h-[500px] bg-sky-200/30 rounded-full blur-[100px]" />
        </div>

        <div className="container mx-auto px-6 relative z-10 text-center">
          <h1 className="text-5xl md:text-6xl font-black tracking-tight mb-8 leading-tight text-slate-900">
            데이터로 읽는 <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-500 to-orange-600">
              투자의 흐름
            </span>
          </h1>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto mb-10 leading-relaxed font-medium">
             STOCK IN U는 기업의 실적, 내부자 거래, 컨센서스 변화를<br className="hidden md:block" />
             한눈에 파악할 수 있는 직관적인 대시보드를 제공합니다.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <button 
              onClick={() => navigate('/shares')}
              className="px-10 py-4 bg-slate-900 hover:bg-slate-800 text-white font-bold rounded-lg text-lg transition-all duration-300 shadow-xl hover:shadow-2xl hover:-translate-y-1"
            >
              시작하기
            </button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="py-24 bg-white border-t border-slate-100">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-slate-900 mb-4">투자자를 위한 핵심 기능</h2>
            <p className="text-slate-500">흩어져 있는 데이터를 한곳에 모았습니다.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {/* Feature 1 */}
            <div className="p-8 rounded-2xl bg-gray-50 border border-slate-200 hover:border-amber-400/50 hover:bg-white hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm border border-slate-100 group-hover:scale-110 transition-transform duration-300">
                <span className="text-2xl">📈</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">실적 변동 공시</h3>
              <p className="text-slate-600 leading-relaxed">
                매일 업데이트되는 잠정 실적 공시를 놓치지 마세요.<br/> 
                전년 동기 대비 매출과 이익의 증감을 즉시 확인하여 <br/>
                실적 호전주를 발굴할 수 있습니다.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="p-8 rounded-2xl bg-gray-50 border border-slate-200 hover:border-sky-400/50 hover:bg-white hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm border border-slate-100 group-hover:scale-110 transition-transform duration-300">
                <span className="text-2xl">👥</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">임원/주주 내역</h3>
              <p className="text-slate-600 leading-relaxed">
                임원과 주요 주주의 장내 매수/매도 흐름을 추적합니다.<br/>
                내부자의 지분 변동과 주가 흐름의 상관관계를 <br/>
                시각화된 차트로 분석해보세요.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="p-8 rounded-2xl bg-gray-50 border border-slate-200 hover:border-rose-400/50 hover:bg-white hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 bg-white rounded-xl flex items-center justify-center mb-6 shadow-sm border border-slate-100 group-hover:scale-110 transition-transform duration-300">
                <span className="text-2xl">📊</span>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">컨센서스 트래킹</h3>
              <p className="text-slate-600 leading-relaxed">
                증권사 리포트의 목표 주가와 실적 전망치를 모니터링합니다.<br/>
                시장의 기대치(컨센서스) 상향/하향 추세를 <br/>
                시계열 데이터로 확인하세요.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 bg-slate-50 border-t border-slate-200">
        <div className="container mx-auto px-6 text-center text-slate-500">
           <div className="mb-4">
             <span className="text-lg font-black text-slate-300 tracking-tighter">STOCKINU</span>
           </div>
          <p className="text-sm mb-2">© 2026 STOCK IN U. All rights reserved.</p>
          <p className="text-sm">문의: stockinu.com@gmail.com</p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
